import { render, staticRenderFns } from "./scan.vue?vue&type=template&id=64bdbf68&scoped=true"
import script from "./scan.vue?vue&type=script&lang=js"
export * from "./scan.vue?vue&type=script&lang=js"
import style0 from "./scan.vue?vue&type=style&index=0&id=64bdbf68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bdbf68",
  null
  
)

export default component.exports